/**
 * @copyright   OnlyOneProd © 2025
 * @authors     Jonathan COULLET <contact@onlyoneprod.com>
 * @link        https://onlyoneprod.com
 * @notice      All information contained herein is,
 *              and remains the property of OnlyOneProd and its suppliers,
 *              Any dissemination of this information or reproduction
 *              of this material is strictly forbidden unless prior
 *              written permission is obtained from OnlyOneProd.
 */

import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";

import router from "./router";
import VueCookieComply from "vue-cookie-comply";

import "./assets/styles/tailwind.sass";
import "./assets/styles/oop-designsystem.sass";

const app = createApp(App);
app.use(router);
app.use(VueCookieComply);
app.mount("#app");
